import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  DialogActions,
  appBarClasses,
  FormGroup,
  FormControlLabel,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { edit_template, get_template, get_fillers, get_profile_data } from "../Api service/APIvariables";
import Switch from "@mui/material/Switch";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const DialogModal = ({
  openDialog,
  setOpenDialog,
  isAddTemplate,
  fetchTemplates,
  template_id,
  hashReadOnlyButton = false,
  setHashReadOnlyButton = false,
  setOpen,
  setMessage,
  setStatus,
  setColor,
}) => {
  const [particularTemplate, setParticularTemplate] = useState({
    id: "",
    template_name: "",
    subject: "",
    message: "",
  });
  const [readOnly, setReadOnly] = useState(false);
  // const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templatesOne, setTemplatesOne] = useState([]);
  const [templates, setTemplates] = useState([]);

  // Typeahead logic
  const quillRef = React.useRef(null);
  const [fillersList, setFillersList] = useState([]);
  const [suggestionQuery, setSuggestionQuery] = useState(null);
  const [cursorPos, setCursorPos] = useState({ top: 0, left: 0, index: 0 });
  const [filteredFillers, setFilteredFillers] = useState([]);

  const isAdmin = window.location.pathname.startsWith("/admin");

  useEffect(() => {
    fetchFillersForMentions();
  }, []);

  const fetchFillersForMentions = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");
      if (!user_id || !token) return;

      const formData = new FormData();
      formData.append("user_id", user_id);

      let sysName = "Your Profile Name";
      let sysEmail = "Your Profile Email";
      let sysMobile = "Your Profile Mobile";
      let sysCompany = "Your Profile Company";

      try {
        const profileRes = await fetch(get_profile_data, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
        const profileResult = await profileRes.json();
        if (!profileResult.error && profileResult.data) {
          sysName = profileResult.data.name || sysName;
          sysEmail = profileResult.data.email || sysEmail;
          sysMobile = profileResult.data.mobile || sysMobile;
          sysCompany = profileResult.data.company_name || sysCompany;
        }
      } catch (e) {}

      const fillersRes = await fetch(get_fillers, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const fillersResult = await fillersRes.json();
      
      const isAdmin = window.location.pathname.startsWith("/admin");

      if (!fillersResult.error && fillersResult.data) {
        const planRank = fillersResult.plan_rank || 1;
        const validFillers = fillersResult.data.filter(f => 
           isAdmin || f.is_system == 0 || f.plan_required <= planRank
        );
        const mappedFillers = validFillers.map((f) => ({
          id: f.filler_key,
          value: f.filler_key,
        }));
        setFillersList(mappedFillers);
      } else {
        setFillersList([]);
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (suggestionQuery !== null) {
      const filtered = fillersList.filter((f) => 
        f.value.toLowerCase().includes(suggestionQuery.toLowerCase())
      );
      setFilteredFillers(filtered);
    }
  }, [suggestionQuery, fillersList]);

  const handleEditorChange = (content, delta, source, editor) => {
    setParticularTemplate((prev) => ({ ...prev, message: content }));
    if (source === 'user') {
      const selection = editor.getSelection();
      if (selection && quillRef.current) {
        const index = selection.index;
        const textBefore = editor.getText(0, index);
        const match = textBefore.match(/\{([A-Za-z0-9_]*)$/);
        
        if (match) {
          setSuggestionQuery(match[1]);
          const bounds = editor.getBounds(index);
          setCursorPos({ top: bounds.top + bounds.height + 10, left: bounds.left, index: index });
        } else {
          setSuggestionQuery(null);
        }
      }
    }
  };

  const handleSelectSuggestion = (fillerValue) => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      const index = cursorPos.index || editor.getLength();
      const textBefore = editor.getText(0, index);
      const match = textBefore.match(/\{([A-Za-z0-9_]*)$/);
      
      if (match) {
        editor.deleteText(index - match[0].length, match[0].length);
        editor.insertText(index - match[0].length, `{{${fillerValue}}}`);
        editor.setSelection(index - match[0].length + `{{${fillerValue}}}`.length);
      } else {
        editor.insertText(index, `{{${fillerValue}}}`);
      }
      
      setSuggestionQuery(null);
      setParticularTemplate((prev) => ({ ...prev, message: editor.root.innerHTML }));
    }
  };

  const modules = React.useMemo(() => ({
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ]
  }), []);

  const fetchSingleTemplate = async () => {
    if (!template_id) return;
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("template_id", template_id);
      const token = localStorage.getItem("auth_token");
      // console.log(token);

      const response = await fetch(get_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch templates");
      }

      const result = await response.json();

      if (result?.data) {
        // Add a unique incremental ID to each template

        setParticularTemplate(result.data);
      } else {
        // Handle case when there are no templates
        // console.log("No templates found:", result.message);
        setTemplates([]);
        setTemplatesOne([]);
        // Optionally show a message to the user or update state for no data
      }
    } catch (error) {
      // console.error("Error fetching templates:", error);
      setLoading(false); // You may want to set loading to false here too
    }
  };
  // console.log(templatesOne);
  useEffect(() => {
    if (template_id) {
      fetchSingleTemplate();
    }
  }, [template_id]);
  console.log(template_id);

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setParticularTemplate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Closing dialog function
  const handleCloseDialog = () => {
    if (hashReadOnlyButton) {
      setHashReadOnlyButton(false);
    }
    setOpenDialog(false);
    setReadOnly(false);
  };
  useEffect(() => {
    setReadOnly(hashReadOnlyButton);
    // console.log("hashReadOnlyButton");
  }, [hashReadOnlyButton]);
  const updateTemplates = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("template_id", particularTemplate.id);
      formData.append("template_name", particularTemplate.template_name);
      formData.append("subject", particularTemplate.subject);
      formData.append("message", particularTemplate.message);
      formData.append("is_system", particularTemplate.is_system ? 1 : 0);
      formData.append("plan_required", particularTemplate.is_system ? (particularTemplate.plan_required || 1) : 0);
      // console.log("Templates to be sent:", JSON.stringify(templatesOne));

      const token = localStorage.getItem("auth_token");
      // console.log("Updating Template - Token:", token);

      const response = await fetch(edit_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to update template");
      }

      const result = await response.json();

      // Check if the result contains expected data
      if (result.error === false || result.success === true) {
        // console.log("Template updated successfully:", result);
        // Close dialog after successful update
        fetchTemplates(); // Refresh the template list
        handleCloseDialog();
        
        if (setOpen) {
          setMessage(result.message || "Template updated successfully!");
          setStatus(true);
          setColor("success");
          setOpen(true);
        }
      } else {
        if (setOpen) {
          setMessage(result.message || "Template update failed.");
          setStatus(false);
          setColor("error");
          setOpen(true);
        }
      }
    } catch (error) {
      if (setOpen) {
        setMessage("Error updating template.");
        setStatus(false);
        setColor("error");
        setOpen(true);
      }
    }
  };
  // useEffect(() => {
  //   updateTemplates();
  // }, [template_id]);

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "90%",
          height: "auto",
        },
      }}
    >
      <DialogTitle>
        {isAddTemplate
          ? "Add Template"
          : readOnly
            ? "View Template"
            : "Edit Template"}{" "}
        {/* <FormGroup>
          <FormControlLabel control={<Switch defaultChecked />} label="Edit" />
        </FormGroup> */}
        {hashReadOnlyButton && (
          <FormControlLabel
            control={
              <Switch
                checked={readOnly}
                onChange={(e) => setReadOnly(e.target.checked)}
              />
            }
            label={readOnly ? "Edit" : "View"}
            labelPlacement="start"
            sx={{ position: "absolute", right: 48, top: 12 }}
          />
        )}
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {isAdmin && (
          <Box mb={2} mt={1} display="flex" alignItems="center" gap={2}>
            <label style={{ fontWeight: 600 }}>Advanced Mode (System Template)</label>
            <input 
              type="checkbox" 
              name="is_system"
              checked={particularTemplate?.is_system == 1} 
              onChange={(e) => setParticularTemplate((prev) => ({ ...prev, is_system: e.target.checked ? 1 : 0 }))} 
              style={{ width: "18px", height: "18px" }}
              disabled={readOnly}
            />
          </Box>
        )}

        {isAdmin && particularTemplate?.is_system == 1 && (
          <Box mb={2}>
            <label style={{ marginBottom: 3, fontWeight: 600, display: 'block' }}>Plan Access</label>
            <select
              name="plan_required"
              value={particularTemplate?.plan_required || 1}
              onChange={(e) => setParticularTemplate((prev) => ({ ...prev, plan_required: e.target.value }))}
              style={{
                display: "block",
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #c4c4c4",
              }}
              disabled={readOnly}
            >
              <option value={1}>Free</option>
              <option value={2}>Plus</option>
              <option value={3}>Pro</option>
              <option value={4}>Unlimited</option>
            </select>
          </Box>
        )}
        <TextField
          inputProps={{
            readOnly: readOnly,
            // disab,
          }}
          disabled={readOnly}
          label="Template Name"
          variant="outlined"
          fullWidth
          name="template_name"
          value={particularTemplate?.template_name}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          inputProps={{
            readOnly: readOnly,
          }}
          disabled={readOnly}
          label="Subject"
          variant="outlined"
          fullWidth
          name="subject"
          value={particularTemplate?.subject ?? ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <label
          style={{
            display: "block",
            fontSize: "16px",
            color: "#333",
            marginTop: "10px",
            marginBottom: "5px",
          }}
        >
          Message
        </label>
        <Box sx={{ position: "relative" }}>
          <ReactQuill
            ref={quillRef}
            readOnly={readOnly}
            value={particularTemplate.message ?? ""}
            onChange={handleEditorChange}
            modules={modules}
            style={{
              height: "200px",
              marginBottom: "40px",
              fontSize: { xs: "8px", sm: "12px" },
              borderRadius: "8px",
            }}
          />
          {suggestionQuery !== null && filteredFillers.length > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: cursorPos.top + 40,
                left: cursorPos.left,
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: "4px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                zIndex: 1000,
                maxHeight: "150px",
                overflowY: "auto",
                minWidth: "150px"
              }}
            >
              {filteredFillers.map((filler, idx) => (
                <Box
                  key={idx}
                  onClick={() => handleSelectSuggestion(filler.value)}
                  sx={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                    fontSize: "14px",
                    color: "#453c72",
                    fontWeight: "500"
                  }}
                >
                  {`{{${filler.value}}}`}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseDialog}
          color="error"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            updateTemplates();
            handleCloseDialog();
          }}
          color="success"
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogModal;
